import { getUserInfo, loginByPassword } from '@/api/auth'
import { actions } from '@/globalState'
const filterVisibleNodes = function (nodes) {
  return nodes
    .map((node) => {
      const children = node.children ? filterVisibleNodes(node.children) : []
      if (node.isShow === '1' || children.length > 0) {
        return { ...node, children }
      }
      return null
    })
    .filter((node) => node !== null)
}

const user = {
  namespaced: true,
  state: () => ({
    token: window.localStorage.getItem('TOKEN') || null,
    menuList: [],
    basicInfo: null
  }),
  getters: {
    isLogin: (state) => state.token != null,
    token: (state) => state.token,
    basicInfo: (state) => state.basicInfo,
    fullMenuList: (state) => {
      return state.menuList
    },
    visibleMenuList: (state) => {
      return filterVisibleNodes(state.menuList)
    }
  },
  mutations: {
    setToken: function (state, payload) {
      state.token = payload
      window.localStorage.setItem('TOKEN', payload)
      actions.setGlobalState({ token: state.token })
    },
    removeToken: (state) => {
      state.token = null
      localStorage.removeItem('TOKEN')
      actions.setGlobalState({ token: null })
    },
    // 菜单相关
    setMenu: (state, menuList) => {
      state.menuList = menuList
    },
    setBasicInfo: (state, basicInfo) => {
      state.basicInfo = basicInfo
    }
  },
  actions: {
    login: async ({ commit, dispatch }, payload) => {
      const loadingId = await dispatch('system/startLoading', null, { root: true })
      return new Promise(resolve => {
        loginByPassword(payload).then((res) => {
          const { code, data } = res
          if (code === 1) {
            commit('setToken', data)
            commit('share/setToken', data, { root: true })
            dispatch('updateUserInfo')
          } else {
            commit('setToken', null)
          }
          dispatch('system/stopLoading', loadingId, { root: true })
          resolve(res)
        }).catch(() => {
          dispatch('system/stopLoading', loadingId, { root: true })
        })
      })
    },
    logout: ({ commit }) => {
      commit('setToken', null)
    },
    /*
      更新用户相关信息：包括菜单、基础用户信息
    */
    updateUserInfo: async ({ dispatch }) => {
      const loadingId = await dispatch('system/startLoading', null, { root: true })
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then((res) => {
            const { success, data } = res
            if (success) {
              const { userInfo, menuInfo } = data
              dispatch('setMenu', JSON.parse(menuInfo))
              dispatch('setBasicInfo', JSON.parse(userInfo))
            }
            resolve(res)
            dispatch('system/stopLoading', loadingId, { root: true })
          })
          .catch((e) => {
            console.error(e)
            reject(e)
            dispatch('system/stopLoading', loadingId, { root: true })
          })
      })
    },
    setMenu: ({ commit }, payload) => {
      commit('setMenu', payload)
    },
    setBasicInfo: ({ commit }, payload) => {
      commit('setBasicInfo', payload)
    }
  }
}

export default user
